/**
 * Do not edit this file it is auto-generated by io-utils / gen-api-models.
 * See https://github.com/pagopa/io-utils
 */
/* eslint-disable  */

import * as t from "io-ts";
import { PaymentOngoingStatusFaultPaymentProblemJson } from "./PaymentOngoingStatusFaultPaymentProblemJson";
import { PaymentExpiredStatusFaultPaymentProblemJson } from "./PaymentExpiredStatusFaultPaymentProblemJson";
import { PaymentCanceledStatusFaultPaymentProblemJson } from "./PaymentCanceledStatusFaultPaymentProblemJson";
import { PaymentDuplicatedStatusFaultPaymentProblemJson } from "./PaymentDuplicatedStatusFaultPaymentProblemJson";

export const NodeProblemJson409 = t.union(
  [
    PaymentOngoingStatusFaultPaymentProblemJson,

    PaymentExpiredStatusFaultPaymentProblemJson,

    PaymentCanceledStatusFaultPaymentProblemJson,

    PaymentDuplicatedStatusFaultPaymentProblemJson
  ],
  "NodeProblemJson409"
);

export type NodeProblemJson409 = t.TypeOf<typeof NodeProblemJson409>;
